module.exports = __webpack_public_path__ + "img/android.4cadfaae.png";